export default __webpack_public_path__ + "static/media/nzl_flag.45705885.png";